import $axios from "@/api";

const state = () => ({
    list_barang: {
        id: '',
        kode_barang: '',
        nama_barang: ''
    }
})

const mutations = {
    ASSIGN_LIST_BARANG(state, payload) {
        state.list_barang = payload
    }
}

const actions = {
    getListBarang( {state, commit }, payload) {
        return new Promise( (resolve, reject) => {
            $axios.get(`barang/list/simple`, {
                params: payload
            })
            .then((response) => {
                resolve(response.data.data)
            })
        })
    },
    getListBarangMitra( {state, commit }, payload) {
        return new Promise( (resolve, reject) => {
            $axios.get(`barang/list/simple/mitra`, {
                params: payload
            })
            .then((response) => {
                resolve(response.data.data)
            })
        })
    },
    getListBarangByBrand( {state, commit }, payload) {
        return new Promise( (resolve, reject) => {
            $axios.get(`barang/list/brand`, {
                params: payload
            })
            .then((response) => {
                resolve(response.data)
            })
        })
    },
    async getListBarangByPenjualan({state}, payload){
        try {
            const response = await $axios.get("barang/list/by_penjualan", {params:payload})
            return response
        } catch (error) {
            console.log(error)
        }
    },
    async listBarangByPenjualanToko({state}, payload){
        try {
            const response = await $axios.get(`barang/list/by_penjualan_toko?id_toko=${payload.id_toko}`)
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async listInvoiceByBaranngAndToko({state}, payload){
        try {
            const response = await $axios.get(`penjualan/list/by_barang?id_toko=${payload.id_toko}&id_barang=${payload.id_barang}`)
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async hargaBarangById({state}, id){
        try {
            const response = await $axios.get(`barang/${id}/harga_barang`)
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async exportBarang({state}, params){
        try {
            const response = await $axios.get(`barang/export`,{params: params})
            return response
        } catch (error) {
            console.log(error)
        }
    },
    async getHargaBarangHistoryById({state}, id){
        try {
            const response = await $axios.get(`barang/${id}/harga_barang/history`)
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
